// Announcement Carousel - Swipe/Slide Functionality

function initAnnouncementCarousel(containerId) {
  var container = document.getElementById(containerId);
  if (!container) return;

  var wrapper = container.querySelector('.announcement-carousel__wrapper');
  var slides = container.querySelectorAll('.announcement-carousel__slide');
  var dots = container.querySelectorAll('.announcement-carousel__dot');
  var prevBtn = container.parentElement.querySelector('.announcement-carousel__arrow--prev');
  var nextBtn = container.parentElement.querySelector('.announcement-carousel__arrow--next');
  var announcementSection = container.closest('.announcement-carousel');

  if (slides.length <= 1) return;

  var currentIndex = 0;
  var autoplayInterval = null;
  var touchStartX = 0;
  var touchEndX = 0;

  // Show slide by index
  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    
    currentIndex = index;
    wrapper.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    
    // Update dots
    dots.forEach(function(dot, i) {
      dot.classList.toggle('announcement-carousel__dot--active', i === currentIndex);
    });
  }

  // Next slide
  function nextSlide() {
    goToSlide(currentIndex + 1);
  }

  // Previous slide
  function prevSlide() {
    goToSlide(currentIndex - 1);
  }

  // Autoplay
  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, 5000); // 5 seconds
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Touch events for swipe
  function handleTouchStart(e) {
    touchStartX = e.changedTouches[0].screenX;
    stopAutoplay();
  }

  function handleTouchEnd(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
    startAutoplay();
  }

  function handleSwipe() {
    var swipeThreshold = 50;
    var diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        nextSlide(); // Swipe left - next
      } else {
        prevSlide(); // Swipe right - prev
      }
    }
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      prevSlide();
      startAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      nextSlide();
      startAutoplay();
    });
  }

  // Dot navigation
  dots.forEach(function(dot, index) {
    dot.addEventListener('click', function() {
      goToSlide(index);
      startAutoplay();
    });
  });

  // Touch events
  container.addEventListener('touchstart', handleTouchStart, { passive: true });
  container.addEventListener('touchend', handleTouchEnd, { passive: true });

  // Pause on hover (if desktop)
  container.addEventListener('mouseenter', stopAutoplay);
  container.addEventListener('mouseleave', startAutoplay);

  // Hide on scroll down, show on scroll up
  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var isHidden = false;
  var scrollTimeout = null;

  function handleScroll() {
    var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Clear any pending timeout
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    
    // Small delay to prevent flickering
    scrollTimeout = setTimeout(function() {
      if (currentScrollTop > lastScrollTop && !isHidden) {
        // Scrolling down - hide
        announcementSection.style.opacity = '0';
        announcementSection.style.transform = 'translateY(-100%)';
        announcementSection.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        isHidden = true;
      } else if (currentScrollTop < lastScrollTop && isHidden) {
        // Scrolling up - show
        announcementSection.style.opacity = '1';
        announcementSection.style.transform = 'translateY(0)';
        isHidden = false;
      }
      lastScrollTop = currentScrollTop;
    }, 50);
  }

  // Add scroll listener
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Initialize
  startAutoplay();
  goToSlide(0);
}

// Auto-initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  var carousels = document.querySelectorAll('.announcement-carousel__swiper');
  carousels.forEach(function(carousel) {
    initAnnouncementCarousel(carousel.id);
  });
});
